import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGARoulette } from 'components/slots/PragmaticDGA/hooks';

import './Roulette.scss';

type RouletteProps = {
  results: PragmaticDGARoulette['last20Results'];
}

const b = block('pragmatic-dga-roulette');

export const Roulette = memo(({ results }: RouletteProps) => (
  <div className={b()}>
    {results.map(({ color, result }, index) => (
      <div key={index} className={b('bet', { color })}>{result}</div>
    ))}
  </div>
), isEqual);
